import { useQuery } from '@tanstack/react-query';
import { getCrmReadiness } from '@/api/endpoints/meetings';
import { bookingGesture, type CustomerCrmView } from '@/services/dialer/bookedMeeting';

/**
 * Quel geste proposer pour « Renseigner un rendez-vous pris ».
 *
 * 🚨 La question posee au serveur n'est pas « quel CRM ce client a-t-il
 * declare » mais « un CRM peut-il recevoir ce rendez-vous maintenant ». Un
 * client declare sur Swoft sans connexion vivante voyait s'ouvrir le
 * calendrier, puis un refus (Kevin, 2026-09-30, deux fois).
 *
 * Tant que la reponse n'est pas la, l'ecran n'affiche rien : montrer un
 * calendrier puis le remplacer par un bouton est precisement ce qu'on evite.
 */
export function useBookingGesture(customer: CustomerCrmView | null, prospectPhone = '') {
  const customerId = customer?.id ?? '';
  const query = useQuery({
    queryKey: ['crm-readiness', customerId, prospectPhone],
    queryFn: () => getCrmReadiness(customerId, prospectPhone),
    staleTime: 60_000,
    retry: false,
  });

  return {
    /** Vrai tant qu'on ne sait pas : ne rien afficher plutot que se dedire. */
    pending: query.isPending,
    // Une erreur de lecture ne doit pas bloquer l'appelant : on retombe sur
    // ce que la fiche annonce, qui reste le meilleur repli disponible.
    gesture: bookingGesture(customer, query.data?.ready ?? false),
  };
}
